import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

// Define a instância apontando para o seu novo Controller de Layout
const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/layoutController');

export default class LayoutRelatorioService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  /**
   * Busca os campos técnicos disponíveis para um tipo específico de relatório (Ex: PRODUCAO_ANALITICO)
   */
  async listarCamposDisponiveis(tipoRelatorio: string) {
    return await this.axios.get(`/campos-disponiveis/${tipoRelatorio}`);
  }

  /**
   * Lista todos os layouts customizados salvos no banco
   */
    async listarTodosLayouts(page: number = 0, size: number = 10) {
    return await this.axios.get(`/listarTodos?page=${page}&size=${size}`);
    }

  /**
   * Busca um layout específico pelo nome técnico
   */
  async buscarPorNome(nome: string) {
    return await this.axios.get(`/buscarPorNome/${nome}`);
  }

  /**
   * Salva ou atualiza um layout (Envia nome, tituloArquivo e layoutJson)
   */
  async salvarLayout(layoutDto: any) {
    return await this.axios.post(`/salvar`, layoutDto);
  }

  /**
   * Exclui um layout permanentemente pelo ID
   */
  async excluirLayout(id: number) {
    return await this.axios.delete(`/excluir/${id}`);
  }
}